function mediaSequence(str) {
  return parseInt(str) || 0;
}

module.exports = mediaSequence;